class ReferenceSlider extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-reference-swiper]');
        this.swiperSlides = document.querySelectorAll('[data-swiper-slide]');
        this.swiper = null;
        this.titles = [];
        this.addEventListeners();
    }

    loadTitles() {
        this.swiperSlides.forEach((el) => {
            this.titles.push(el.dataset.title);
        });
    }

    constructSwiper(titles) {
        this.swiper = new Swiper(this.swiperEl, {
            effect: 'fade',
            disableOnInteraction: true,
            autoplay: {
                // v případě změny nastavit také ve stylu reference.scss
                delay: 5000,
            },
            pagination: {
                el: '[data-reference-pagination]',
                clickable: 'true',
                type: 'bullets',
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"><svg class="swiper-progress-bar" width="41" height="41"><circle class="circle-origin" r="20" cx="20.5" cy="20.5"></circle></svg><span>' + (titles[index]) + '</span></span>';
                },
            },
            slidesPerView: 1,
        });
    }

    addEventListeners() {
        document.addEventListener("DOMContentLoaded", () => {
            this.loadTitles();
            this.swiperEl && this.constructSwiper(this.titles);
        });
    }
}
